import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SocketContext = createContext({ socket: null, connected: false });

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const s = io(SOCKET_URL, {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1500,
      // Sans ce plafond, socket.io-client retente indéfiniment (toutes les
      // 1,5 à 5s, pour toujours) quand aucun serveur temps réel ne répond —
      // si le backend n'est simplement pas lancé (dev local sans server/),
      // ça revient à polluer la console sans fin pour rien. Le compteur de tentatives repart à
      // zéro après chaque connexion réussie (voir socket.io-client), donc ce
      // plafond ne limite jamais une vraie coupure réseau pendant le pilote
      // (chauffeur/passager, cf. DriverDashboard.jsx / DashboardContext.jsx)
      // — seulement le cas où aucun serveur n'a jamais répondu du tout.
      reconnectionAttempts: 10,
    });

    // Exposé dès la création (même avant la poignée de main) : socket.io-client
    // met en file d'attente les emit() tant que la connexion n'est pas établie,
    // donc les composants qui font `if (!socket) return` peuvent s'y fier tout
    // de suite. Si le serveur temps réel (server/) n'est pas lancé, `connected`
    // reste simplement à false — l'app entière parle au vrai backend REST/API,
    // seul le temps réel (position live, dispatch) reste alors indisponible.
    setSocket(s);
    s.on('connect', () => setConnected(true));
    s.on('disconnect', () => setConnected(false));
    s.on('connect_error', () => setConnected(false));

    return () => {
      s.disconnect();
      setSocket(null);
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, connected }}>
      {children}
    </SocketContext.Provider>
  );
}

export const useSocket = () => useContext(SocketContext);
